import { useAuth } from '../context/AuthContext';
import { useWindowWidth } from '../hooks';

// View as (the director, 3 Nov 2026: "as a Director, I would also like to see what
// Setters and Operators can see"). The server treats the requests as that role,
// so this shows what they really get, not an imitation; nothing can be saved, and
// it ends when the app is closed.

const AMBER = '#f59e0b', TEAL = '#14b8a6', DIM = '#9ca3af', LINE = '#2a3040';
const LABEL = { director: 'Director', setter: 'Setter', operator: 'Operator' };

// The strip across every page while viewing.
export function ViewAsStrip() {
  const { viewAs, setViewAs } = useAuth();
  const phone = useWindowWidth() < 900;
  if (!viewAs) return null;
  return (
    <div role="status" style={{ position: 'sticky', top: phone ? 44 : 52, marginTop: phone ? -64 : 0, zIndex: 850, background: '#3b2a0a', borderBottom: `1px solid ${AMBER}`, color: '#fde68a',
      padding: '7px 14px', display: 'flex', flexWrap: 'wrap', gap: '4px 12px', alignItems: 'center', fontSize: 13, fontFamily: 'system-ui, sans-serif' }}>
      <span>Viewing as <b>{LABEL[viewAs]}</b>. This is what they see, and nothing can be saved.</span>
      <button onClick={() => setViewAs(null)} style={{ marginLeft: 'auto', background: AMBER, color: '#1c1404', border: 'none', borderRadius: 7, padding: '5px 11px', fontWeight: 800, fontSize: 12.5, cursor: 'pointer', fontFamily: 'inherit' }}>
        Back to Director
      </button>
    </div>
  );
}

// The choice: only for someone who is really a director.
export function ViewAsPicker({ onPicked }) {
  const { realLevel, viewAs, setViewAs } = useAuth();
  if (realLevel !== 'director') return null;
  const now = viewAs || 'director';
  return (
    <div role="group" aria-label="See the app as" style={{ display: 'flex', gap: 4 }}>
      {['director', 'setter', 'operator'].map(l => (
        <button key={l} aria-pressed={now === l} onClick={() => { if (l !== now) setViewAs(l === 'director' ? null : l); if (onPicked) onPicked(); }}
          style={{ background: now === l ? TEAL : 'none', color: now === l ? '#06221f' : DIM, border: `1px solid ${now === l ? TEAL : LINE}`, borderRadius: 7, padding: '6px 11px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'system-ui, sans-serif' }}>
          {LABEL[l]}
        </button>
      ))}
    </div>
  );
}

// A page this role does not get: says so, and where to go instead.
export function NotForYou() {
  const { viewAs, user } = useAuth();
  return (
    <div style={{ padding: '60px 20px', textAlign: 'center', color: DIM, fontFamily: 'system-ui, sans-serif', minHeight: '60vh', background: '#0f1117' }}>
      <div style={{ fontSize: 18, fontWeight: 800, color: '#f0f2f5', marginBottom: 6 }}>This page is not part of {viewAs ? `a ${LABEL[viewAs]}'s` : (user?.name ? 'your' : 'this')} view</div>
      <div style={{ fontSize: 14, maxWidth: 460, margin: '0 auto 16px', lineHeight: 1.5 }}>A director can open it. If you need something from it, ask a director, or use Suggest a change beside the bell.</div>
      <a href="/today" style={{ color: TEAL, fontWeight: 700 }}>Go to Today</a>
    </div>
  );
}
